module.exports = __webpack_public_path__ + "static/osunkalu-47207e416216d2aa2661129bd2620589.png";